module.exports = __webpack_public_path__ + "img/jcnr1.e782c3b0.png";